/**
 * Probe whether the browser can currently create a WebGL2 context.
 *
 * deck.gl requires WebGL2 and creates its rendering device asynchronously
 * without awaiting the failure, so when the browser refuses to create a
 * context — e.g. Chrome blocks a page after repeated context losses with
 * "Web page caused context loss and was blocked" — the error escapes as an
 * unhandled promise rejection (Sentry HORIZON-FE-2S0). Callers probe first
 * and fall back to DOM-based marker rendering instead of mounting the
 * deck.gl overlay.
 */
export function canCreateWebGL2Context() {
  try {
    const probeCanvas = document.createElement('canvas');
    const probeContext = probeCanvas.getContext('webgl2');

    if (!probeContext) {
      return false;
    }

    // Release the probe context right away: Chrome caps live WebGL contexts
    // (16 per page) and silently loses the oldest one past the cap, so an
    // unreleased probe would itself contribute to the context losses that get
    // a page blocked.
    probeContext.getExtension('WEBGL_lose_context')?.loseContext();

    return true;
  } catch {
    return false;
  }
}
